import { uid } from "./core";
import { toNode } from "./html";

export interface IView {
	getRootView(): any;
	paint(): void;
	mount(container: any, vnode?: any): void;
}

export interface IViewLike {
	mount?(container: any, vnode?: any): void;
	getRootView(): any;
}

export class View {
	public config: any;
	protected _container: any;
	protected _uid: any;
	protected _doNotRepaint: boolean;
	private _view: any;

	constructor(_container, config) {
		this.config = config || {};
		this._uid = this.config.rootId || uid();
	}

	public mount(container, vnode?: any) {
		if (vnode) {
			this._view = vnode;
		}
		if (container && this._view && this._view.mount) {
			// init view inside of HTML container
			this._container = toNode(container);
			if (this._container.tagName) {
				this._view.mount(this._container);
			} else if (this._container.attach) {
				this._container.attach(this);
			}
		}
	}

	public unmount() {
		const rootView = this.getRootView();
		if (rootView && rootView.node) {
			rootView.unmount();
			this._view = null;
		}
	}

	public getRootView() {
		return this._view;
	}
	public getRootNode(): HTMLElement {
		return this._view && this._view.node && this._view.node.el;
	}

	public paint() {
		if (
			this._view && // was mounted
			(this._view.node || // already rendered node
				this._container)
		) {
			// not rendered, but has container
			this._doNotRepaint = false;
			this._view.redraw();
		}
	}
}

export function toViewLike(view) {
	return {
		getRootView: () => view,
		paint: () => view.node && view.redraw(),
		mount: container => view.mount(container),
	};
}
